<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container grid-list-xl pt-0>
            <page-tool-bar
                show_search
                show_month
                show_building
                :loading="loader"
                :search.sync="search"
                :chosen_month.sync="chosen_month"
                :chosen_building.sync="chosen_building"
            >
                <v-flex shrink>
                    <div class="text-right">
                        <v-btn @click="dialog = !dialog" color="green" dark>
                            <v-icon small dark class="mr-1">add_box</v-icon>Tạo phiếu điều chỉnh
                        </v-btn>
                        <v-btn
                            :loading="export_csv.loading"
                            @click="exportCSV"
                            color="primary"
                            dark
                        >XUẤT EXCEL</v-btn>
                        <export-csv-button
                            :trigger="export_csv.trigger"
                            :title="export_csv.title"
                            :rows="export_csv.rows"
                        ></export-csv-button>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            :rows-per-page-items="rowPerPage"
                            :headers="headers"
                            :items="filtered_items"
                            disable-initial-sort
                            :loading="form_loader"
                            :search="search"
                            item-key="id"
                        >
                            <template #items="props">
                                <tr>
                                    <td class="text-center text-no-wrap" v-if="props.item.is_valid !== false">
                                        <v-menu offset-y>
                                            <v-btn icon slot="activator">
                                                <v-icon small color="#464D69">settings</v-icon>
                                            </v-btn>
                                            <v-list>
                                                <v-list-tile @click="cancelReceipt(props.item)">
                                                    <v-list-tile-action>
                                                        <v-icon small class="zmdi zmdi-delete"></v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>Hủy phiếu</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </td>
                                    <td class="text-center text-no-wrap" v-else>
                                        <span class="v-badge error">Đã hủy</span>
                                    </td>
                                    <td class="text-center text-no-wrap" :class="{'text-strike': props.item.is_valid === false}">{{ props.item.receipt_id }}</td>
                                    <td
                                        class="text-center text-no-wrap"
                                    >{{ props.item.adjustment_date | formatTimeServer }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.building }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.month }}</td>
                                    <td
                                        class="text-right text-no-wrap"
                                    >{{ props.item.amount | formatNumber }}</td>
                                    <td class="text-center text-no-wrap">{{ ADJUSTMENT_TYPE_DISPLAY_MAPPING[props.item.type] }}</td>
                                    <td class="text-center text-no-wrap">{{ props.item.note }}</td>
                                </tr>
                            </template>
                            <template #no-data>Chưa có thông tin</template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <dialog-tao-phieu-dieu-chinh
			:dialog="dialog"
            @changeDialogState="dialog = $event"
            @getData="getData()"
        ></dialog-tao-phieu-dieu-chinh>
    </div>
</template>
<script>
import api from "Api";
import moment from "moment";
import {
    buildParamQuery,
    formatTimeServer,
    dayDiff,
    translateWalletName
} from "Helpers";
import { list_building, ADJUSTMENT_TYPE_DISPLAY_MAPPING } from "Constants/db-config";
import { Wallet } from "Components/Form";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import DialogTaoPhieuDieuChinh from "Components/Phieu/DialogTaoPhieuDieuChinh"; 

export default {
    name: "phieu-dieu-chinh",
    components: {
        Wallet,
        ExportCsvButton,
        DialogTaoPhieuDieuChinh,
    },
    data() {
        return {
            dialog: false,
            menu_receipt_data_month: false,
            menu_receipt_date_collected: false,
            menu_month_picker: false,
            total_amount_must_collect: 0,
            over_collected_amount_allowed: 200000,
            chosen_month: moment()
                .subtract(1, "months")
                .toISOString()
                .substr(0, 7),
            list_building : [
				...list_building,
				{text: 'Tất cả', value: ''}

			],
            loader: false,
            headers: [
                {
                    text: "Thao tác",
                    align: "center",
                    sortable: false,
                    value: "action"
                },
                {
                    text: "Mã phiếu",
                    align: "center",
                    sortable: true,
                    value: "receipt_id"
                },
                {
                    text: "Ngày điều chỉnh",
                    align: "center",
                    sortable: true,
                    value: "adjustment_date"
                },
                {
                    text: "Tòa nhà",
                    align: "center",
                    sortable: true,
                    value: "building"
                },
                {
                    text: "Số phòng",
                    align: "center",
                    sortable: true,
                    value: "room_id"
                },
                {
                    text: "Tháng",
                    align: "center",
                    sortable: true,
                    value: "month"
                },
                {
                    text: "Số tiền",    
                    align: "center",
                    sortable: true,
                    value: "amount"
                },
                {
                    text: "Loại điều chỉnh",
                    align: "center",
                    sortable: true,
                    value: "type"
                },
                {
                    text: "Giải thích",
                    align: "center",
                    sortable: true,
                    value: "note"
                },
            ],
            items: [],
            loading: {
                submit: false
            },
            alert: {
                show: false,
                text: "",
                type: "error"
            },
            form_loader: false,
            chosen_building: "",
            rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
            search: "",
            export_csv: {
                loading: false,
                trigger: false,
                title: "",
                rows: []
            },
            chosen_receipt: {},
            trigger_edit_component: false,
            ADJUSTMENT_TYPE_DISPLAY_MAPPING,
        };
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms;
        },
        room_ids() {
            return this.rooms.filter(
                room => room.building === this.form.building
            );
        },
        filtered_items() {
            if (!this.search) return this.items.slice(0);

			const searchArray = this.search.toLowerCase().split(' ')
			
			if (searchArray.length > 1){
				return this.items.filter(item => item.object && searchArray.includes(item.object.toLowerCase()))
			}

			const search = searchArray[0];

			return this.items.filter(item => {
					if (
						item.object.toLowerCase().includes(search)
					)
							return true
					return false
			})
        }
    },
    watch: {
        chosen_month: {
            handler: function(nv) {
                this.getData();
                this.chosen_month_locale = formatTimeServer(nv + "-01");
            },
            immediate: true
        },
        chosen_building: {
            handler: function(nv) {
                this.getData();
            },
            immediate: true
        }
    },
    methods: {
        getData: async function() {
            this.items = [];
            const params = {
                building: this.chosen_building,
                month: this.chosen_month
            };
            const query = buildParamQuery(params);
            this.form_loader = true;
            let data = await api.findAdjustment(query);
            this.form_loader = false;
            this.loader = false;
            if (data.status === 200) {
                this.items = data.data
                    .map(adjustment => adjustment)
                    .sort((a, b) =>
                        dayDiff(b.adjustment_date, a.adjustment_date)
                    );
            } else {
                console.log("Lỗi lúc tải phiếu thu");
            }
        },
        cancelReceipt(receipt) {
            let that = this;
            swal.fire({
                title: 'Hủy phiếu điều chỉnh',
                text: `Bạn có chắc muốn hủy phiếu điều chỉnh:\n\nMã chứng từ: ${receipt.receipt_id}\nSố phòng: ${receipt.room_id} ?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Hủy phiếu',
                cancelButtonText: 'Trở về'
            }).then(async (result) => {
                if (result.value) {
                    that.$store.commit("loading", true);
                    let data = await api.deleteAdjustment({ id: receipt._id });
                    that.$store.commit("loading", false);
                    if (data.status == 200) {
                        swal.fire('Thành công', data.data.message, 'success');
                        receipt.is_valid = false;
                        that.getData();
                    } else {
                        swal.fire('Lỗi', data.message, 'error');
                    }
                }
            });
        },
        formatMoney: function() {
            let collected_amount = this.form.collected_amount;
            collected_amount = collected_amount
                ? collected_amount
                      .toString()
                      .replace(/,/g, "")
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : 0;
            this.form.collected_amount = collected_amount;
        },
        formatNumberToMoney: function(amount = 0) {
            return amount
                      .toString()
                      .replace(/,/g, "")
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        triggerDialog: function (){
            this.trigger_dialog_tao_phieu_dieu_chinh = !this.trigger_dialog_tao_phieu_dieu_chinh
        },
        exportCSV: function() {
            const rows = this.filtered_items.map(item => {
                return {
                    "Tòa nhà": item.building,
                    "Số phòng": item.room_id,
                    "Số chứng từ": item.receipt_id,
                    "Ngày điều chỉnh": formatTimeServer(item.date_collected),
                    "Số tiền": item.collected_amount,
                    "Trạng thái phiếu": item.is_collected
                        ? "CG đã thu"
                        : "CG chưa thu",
                    Tháng: item.month,
                    "Hình thức": item.wallet_account_id
                        ? translateWalletName(item.wallet_account_id)
                        : "",
                    "Phiếu CG": item.receipt_collected_id,
                    "Ghi chú": item.note
                };
            });
            this.export_csv.rows = rows;
            this.export_csv.title = "phieu-dieu-chinh-thang" + this.chosen_month;
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
};
</script>

<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
    .text-strike {
        text-decoration: line-through;
        opacity: 0.6;
    }
</style>